const enUS = {
  第一作者必须填写: 'The first author must be filled in',
  自动保存: 'Auto Save',
  添加作者: 'Add author',
  修改作者: 'Revising author',
  作者信息: 'Author Information',
  第一作者: 'First Author',
  其他作者: 'Other Author',
  确定: 'Confirm',
  取消: 'Cancel',
  存为草稿: 'Save as Draft',
  直接提交: 'Submit Directly',
  '勾选收集通讯作者时，手机邮箱必须至少有一项':
    'Select collect the author as a communicator, the mobile phone number and email must have at least one',
  '请输入{0}字符': 'Please enter {0} characters',
  '请输入至少{0}字符': 'Please enter at least {0} characters',
  '请输入最多{0}字符': 'Please enter at most {0} characters',
  分享: 'Share',
  保存: 'Save',
  参会人: 'Attendee',
  演讲嘉宾: 'Speaker',
  展商证件人员: 'ExhibitorMember',
  展团: 'Agency',
  参会团体: 'Organization',
  展商: 'Exhibitor',
  文件: 'File',
  压缩包: 'Zip',
  图片: 'Image',
  视频: 'Video',
  自定义: 'Custom',
  是否开启表单: 'Enable Form',
  主题色: 'Theme Color',
  整体布局: 'Overall Layout',
  标签展示模式: 'Label Display Mode',
  同行: 'Companion',
  单独一行: 'Single Row',
  标签宽度: 'Label Width',
  页眉展示: 'Show Header',
  隐藏标题: 'Hide Title',
  提交按钮文案: 'Submit Button Text',
  提交成功后: 'After Submission Success',
  分组名称: 'Group Name',
  '分组名称以中文符号，分割': 'Group Names Separated by Chinese Punctuation',
  每人可填写次数: 'Submission Limit per Person',
  是否允许修改结果: 'Allow Editing After Submission',
  修改截止时间: 'Edit Deadline',
  默认值: 'Default Value',
  必填: 'Required',
  隐藏字段: 'Hidden Field',
  占位符: 'Placeholder',
  前台只读模式: 'Read-Only in Frontend',
  最少选择: 'Minimum Selections',
  最多选择: 'Maximum Selections',
  弹窗说明: 'Popup Description',
  点击查看详情: 'Click to View Details',
  是否带清除按钮: 'Show Clear Button',
  前置标签: 'Prefix Label',
  后置标签: 'Suffix Label',
  前缀: 'Prefix',
  后缀: 'Suffix',
  其他选项输入框占位符: 'Other Option Input Placeholder',
  其他选项输入框必填: 'Other Option Input Required',
  排列方式: 'Layout Direction',
  横向: 'Horizontal',
  纵向: 'Vertical',
  仅管理可用: 'Admin Only',
  允许重复: 'Allow Duplicates',
  最长可选择天数: 'Maximum Selectable Days',
  姓名: 'Name',
  最少填写字数: 'Minimum Characters',
  最多填写字数: 'Maximum Characters',
  校验正则表达式: 'Validation Regex',
  填写正则表达式: 'Input Regex Expression',
  高级设置: 'Advanced Settings',
  手机: 'Mobile Number',
  国际区号: 'International Area Code',
  邮箱: 'Email',
  请输入格式正确的邮箱: 'Please Enter a Valid Email Address',
  地址: 'Address',
  所在地区: 'Region',
  邮编: 'Postal Code',
  日期选择: 'Date Picker',
  开始时间: 'Start Time',
  结束时间: 'End Time',
  格式: 'Format',
  日期时间: 'DateTime',
  日期: 'Date',
  时间: 'Time',
  下拉菜单: 'Dropdown Menu',
  选项: 'Options',
  富文本: 'Rich Text',
  单项选择: 'Single Choice',
  文件上传: 'File Upload',
  按钮文字: 'Button Text',
  '文件最大体积（MB）': 'Maximum File Size (MB)',
  最多可上传文件数: 'Maximum Number of Files',
  上传文件类型: 'File Upload Type',
  文件格式限制: 'File Format Restrictions',
  隐藏默认提示文案: 'Hide Default Prompt Text',
  身份证是否唯一: 'Is ID Number Unique',
  多行文本: 'Multi-line Text',
  高度自动: 'Auto Height',
  指定高度: 'Fixed Height',
  单行文本: 'Single-line Text',
  性别: 'Gender',
  评分: 'Rating',
  最少评分: 'Minimum Rating',
  最多评分: 'Maximum Rating',
  是否默认勾选: 'Checked by Default',
  公司: 'Company',
  数字: 'Number',
  最小值: 'Minimum Value',
  最大值: 'Maximum Value',
  开关: 'Toggle',
  是否默认开启: 'Enabled by Default',
  多项选择: 'Multiple Choice',
  描述: 'Description',
  展示内容: 'Display Content',
  '数字（滑动选择）': 'Number (Slider)',
  带滑动条: 'With Slider',
  关联其它记录: 'Link to Other Records',
  请选择要关联表: 'Please Select Table to Link',
  是否允许关联多条记录: 'Allow Linking Multiple Records',
  显示字段: 'Displayed Fields',
  关联参会个人: 'Link to Individual Attendee',
  请选择关联参会个人: 'Please Select Individual Attendee',
  关联参会团体: 'Link to Organization Attendee',
  请选择关联参会团体: 'Please Select Organization Attendee',
  容器: 'Container',
  系统字段: 'System Field',
  部门: 'Department',
  职务: 'Position',
  证件: 'ID Document',
  头像: 'Avatar',
  国籍: 'Nationality',
  车辆编号: 'Vehicle Number',
  展位号: 'Booth Number',
  车牌号: 'License Plate Number',
  生日: 'Birthday',
  PPT中文: 'PPT (Chinese)',
  PPT英文: 'PPT (English)',
  姓: 'Surname',
  名: 'Given Name',
  工作单位: 'Organization',
  '工作单位（英文）': 'Organization (English)',
  '科室/部门': 'Department',
  邮政编码: 'Postal Code',
  出生日期: 'Date of Birth',
  分类: 'Category',
  摘要题目: 'Abstract Title',
  拟投稿议题: 'Proposed Submission Topic',
  投稿类别: 'Submission Category',
  关键字: 'Keywords',
  摘要内容: 'Abstract Content',
  摘要附件: 'Abstract Attachment',
  拟交流类型: 'Preferred Presentation Type',
  英文题目: 'Title (English)',
  方法: 'Method',
  结果: 'Result',
  结论: 'Conclusion',
  参考文献: 'References',
  中文壁报: 'Poster (Chinese)',
  英文壁报: 'Poster (English)',
  中文全文附件: 'Full Paper Attachment (Chinese)',
  英文全文附件: 'Full Paper Attachment (English)',
  视频附件: 'Video Attachment',
  '开启后，护照信息将自动填充至列表': 'Enable Auto-Fill of Passport Info',
  是否开启OCR识别: 'Enable OCR Recognition',
  识别后是否允许修改: 'Allow Editing After Recognition',
  暂无开启OCR权限: 'OCR Permission Not Enabled',
  添加: 'Add',
  编辑: 'Edit',
  查看: 'View',
  '选择后，前台用户在相应的表单中可以查看该字段，但无法进行修改。':
    'After selection, the front-end user can view the field in the corresponding form, but cannot modify it.',
  护照: 'Passport',
  展示签到二维码: 'Show Check-in QR Code',
  请填写完整的作者信息: 'Please fill in the complete author information',
  提交: 'Submit',
  展示系统默认页: 'Show System Default Page',
  跳转网页: 'Redirect to Website',
  下载文档: 'Download Document',
  请上传不超过: 'Please upload no more than',
  格式的文件: 'files',
  请输入网址: 'Please enter the website',
  重新上传: 'Re-upload',
  上传文档: 'Upload Document',
  网页地址: 'Website Address',
  保存成功: 'Save Success',
  原始链接: 'Original Link',
  复制成功: 'Copy Success',
  删除成功: 'Delete Success',
  提示: 'Tips',
  '删除分享链接后，该链接相关的统计数据将会丢失，是否确认删除？':
    'Deleting the share link will result in the loss of related statistics. Are you sure you want to delete it?',
  系统错误: 'System Error',
  嵌入: 'Embed',
  确认: 'Confirm',
  '您可以选择已有的链接，或者创建一个新的分享链接，创建链接时可以添加参数用于跟踪数据来源':
    'You can select an existing link or create a new share link. When creating a link, you can add parameters to track data sources.',
  复制: 'Copy',
  删除: 'Delete',
  下载二维码: 'Download QR Code',
  添加分享链接: 'Add Share Link',
  分享链接: 'Share Link',
  链接名称: 'Link Name',
  来源: 'Source',
  媒介: 'Medium',
  名称: 'Campaign',
  内容: 'Content',
  请输入链接名称: 'Please enter the link name',
  请输入来源: 'Please enter the source',
  请输入媒介: 'Please enter the medium',
  请输入名称: 'Please enter the campaign',
  请输入内容: 'Please enter the content',
  '你可以上传不超过{0}MB的{1}格式的图片，图片宽度建议为：800px，高度不限（为了有更好的显示效果，建议高度不要超过400px）。':
    'You can upload no more than {0}MB of {1} format images. The image width is recommended to be 800px, and the height is unlimited (for better display, it is recommended that the height should not exceed 400px).',
  上传图片: 'Upload Image',
  选择参会身份: 'Select Attendee Type',
  选择会展: 'Select Event',
  选择报告人: 'Select Speaker',
  '选择参会人/团体': 'Select Attendee/Organization',
  未报名时跳转到指定人群类别报名页: 'Redirect to Specified Group Category Page When Not Registered',
  '允许待审核/审核需修改/待付款参会人提交表单':
    'Allow Submission by Pending Review/Review Required/Pending Payment Attendee',
  可选证件类型: 'Optional ID Type',
  请选择证件类型: 'Please select the ID type',
  护照签发日期: 'Passport Issue Date',
  护照到期日期: 'Passport Expire Date',
  请选择护照签发日期: 'Please select the passport issue date',
  请选择护照到期日期: 'Please select the passport expire date',
  护照到期日期必须晚于护照签发日期: 'Passport Expire Date must be later than Passport Issue Date',
  '护照已过期，请选择有效的到期日期': 'Passport has expired, please select a valid expiration date',
  '护照有效期预警（天）': 'Passport Expire Date Warning (Days)',
  '您的护照即将到期，根据出入境管理规定，距到期不足{0}天将无法办理签证及出入境手续，请及时更新护照':
    'Your passport is about to expire. According to immigration regulations, if there are less than 30 days until expiration, you will not be able to apply for a visa or complete immigration procedures. Please update your passport in time.',
  提交并继续: 'Submit and Continue',
  是否显示提交并继续: 'Show Submit and Continue',
  是否唯一: 'Is Unique'
}

export default enUS
